import React from 'react';
import { BookOpenIcon, ClockIcon, CheckCircleIcon, PlayIcon } from 'lucide-react';
const CourseProgressWidget = () => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-1015">
      <div className="p-5" data-id="element-1016">
        <h2 className="text-base font-semibold text-gray-800 mb-5" data-id="element-1017">
          Progresso del Corso
        </h2>
        <div className="flex flex-col md:flex-row mb-6 gap-5" data-id="element-1018">
          <div className="w-full md:w-2/5 aspect-video rounded-lg overflow-hidden relative" data-id="element-1019">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xedz9op8eQZKNp15eJhgwy/Screenshot-2025-06-21-alle-14-42-31.png" alt="Lezione di Innovazione Sostenibile" className="w-full h-full object-cover rounded-lg" data-id="element-1020" />
            <div className="absolute inset-0 bg-black bg-opacity-30 flex items-center justify-center" data-id="element-1021">
              <div className="w-16 h-16 rounded-full bg-black/30 backdrop-blur-md flex items-center justify-center cursor-pointer hover:bg-black/40 transition-all" data-id="element-1022">
                <PlayIcon size={28} className="text-white ml-1" data-id="element-1023" />
              </div>
            </div>
          </div>
          <div className="w-full md:w-2/3 flex flex-col justify-between" data-id="element-1024">
            <div data-id="element-1025">
              <div className="flex items-center justify-between mb-4" data-id="element-1026">
                <div data-id="element-1027">
                  <h3 className="font-medium text-gray-800 text-lg" data-id="element-1028">
                    Innovazione Sostenibile per le Imprese
                  </h3>
                  <p className="text-sm text-gray-500" data-id="element-1029">Modulo 3 di 8</p>
                </div>
                <div className="bg-gray-200 text-gray-700 text-xs px-2 py-1 rounded-full" data-id="element-1030">
                  IN CORSO
                </div>
              </div>
              <div className="mb-2 flex justify-between text-sm" data-id="element-1031">
                <span className="text-gray-600" data-id="element-1032">Progresso</span>
                <span className="font-medium text-gray-800" data-id="element-1033">42%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2 mb-4" data-id="element-1034">
                <div className="bg-custom-green h-2 rounded-full" style={{
                width: '42%'
              }} data-id="element-1035"></div>
              </div>
              <div className="flex flex-col sm:flex-row justify-between text-sm mb-4 gap-2 sm:gap-0" data-id="element-1036">
                <div className="flex items-center text-gray-600" data-id="element-1037">
                  <ClockIcon size={16} className="mr-1" data-id="element-1038" />
                  <span data-id="element-1039">5h 23m rimanenti</span>
                </div>
                <div className="flex items-center text-gray-600" data-id="element-1040">
                  <CheckCircleIcon size={16} className="mr-1" data-id="element-1041" />
                  <span data-id="element-1042">12/28 lezioni completate</span>
                </div>
              </div>
            </div>
            <button className="w-full py-2 bg-custom-green hover:bg-custom-green/90 text-white font-medium rounded-lg transition-colors" data-id="element-1043">
              Continua a Studiare
            </button>
          </div>
        </div>
      </div>
    </div>;
};
export default CourseProgressWidget;